<template>
	<v-dialog v-model="dialog" persistent max-width="900" scrollable content-class="rounded-lg">
		<v-card class="bg-dark-white" v-if="Object.keys(detailTransactionProduct).length > 0">
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 font-size-xs-11 cl-primary">Detail Pembelian {{ detailTransactionProduct.transaction_code }}</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="py-3">
				<v-row>
					<v-col cols="12 mt-3 pb-0">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
							<div class="d-flex flex-wrap">
								<v-col cols="12" sm="6" md="4" class="py-0 font-size-10">
									<div class="cl-grey font-weight-bold">Tanggal</div>
									<div class="cl-dark-green">{{ detailTransactionProduct.transaction_datetime | tanggaljam }}</div>
								</v-col>
								<v-col cols="12" sm="6" md="4" class="py-0 font-size-10">
									<template v-if="detailTransactionProduct.transaction_receipt_number">
										<div class="cl-grey font-weight-bold">No Resi</div>
										<div class="cl-dark-green">{{ detailTransactionProduct.transaction_receipt_number ? detailTransactionProduct.transaction_receipt_number : '-' }}</div>
									</template>
								</v-col>
								<v-col cols="12" sm="6" md="4" class="py-0 font-size-10 text-md-right my-auto">
									<div class="cl-grey font-weight-bold">Status</div>
									<div class="text-capitalize">
										<v-chip small :color="detailTransactionProduct.transaction_status | toColorTransaction" class="font-weight-bold white--text text-uppercase">{{ detailTransactionProduct.transaction_status_formatted }}</v-chip>
									</div>
								</v-col>
								<v-col cols="12" sm="12" md="12" class="pt-2 pb-0 font-size-10">
									<template v-if="detailTransactionProduct.transaction_notes">
										<div class="cl-grey font-weight-bold">Catatan</div>
										<div class="cl-dark-green">{{ detailTransactionProduct.transaction_notes }}</div>
									</template>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="mt-5 py-0">
						<div class="px-3 d-flex flex-wrap">
							<v-col md="1" class="py-0"></v-col>
							<v-col md="8" class="pl-md-5 py-0">
								<div class="font-size-10 font-weight-bold">Item</div>
							</v-col>
							<v-col md="1" class="py-0 text-md-center">
								<div class="font-size-10 font-weight-bold">Qty</div>
							</v-col>
							<v-col md="2" class="py-0 text-md-right">
								<div class="font-size-10 font-weight-bold">Total</div>
							</v-col>
						</div>
						<v-card class="mt-2 pa-3 elevation-0 rounded-xl hover-shadow" v-for="(product, idp) in detailTransactionProduct.transaction_detail" :key="idp">
							<div class="d-flex flex-wrap">
								<v-col md="1" class="py-0 px-0 my-auto">
									<v-img contain width="45px" height="45px" class="mx-auto rounded-xl" :src="product.transaction_detail_product_image ? product.transaction_detail_product_image : '/assets/image/user-pict.jpg'"></v-img>
								</v-col>
								<v-col md="8" class="pl-md-5 py-0 my-auto">
									<div class="cl-dark-green font-size-10">{{ product.transaction_detail_product_name }}</div>
									<div class="cl-dark-green font-size-10">
										{{ product.transaction_detail_unit_price | toRupiah }}
									</div>
								</v-col>
								<v-col md="1" class="py-0 my-auto text-md-center">
									<div class="cl-dark-green font-size-10 font-weight-bold">{{ product.transaction_detail_qty }}</div>
								</v-col>
								<v-col md="2" class="py-0 my-auto text-md-right">
									<div class="cl-dark-green font-size-10 font-weight-bold">{{ (parseInt(product.transaction_detail_unit_price) * parseInt(product.transaction_detail_qty)) | toRupiah }}</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="my-5 py-0">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
							<div class="px-3 d-flex">
								<v-icon class="cl-primary">mdi-database-outline</v-icon>
								<div class="pl-1 cl-primary font-size-10 font-weight-bold">Ringkasan Transaksi</div>
							</div>
							<div class="px-3">
								<v-card outlined class="mt-2 pa-3 elevation-0 rounded-xl">
									<div class="d-flex flex-wrap">
										<v-col md="6" class="py-0">
											<div class="cl-dark-green font-size-11 font-weight-bold">Total Pembayaran</div>
										</v-col>
										<v-col md="6" class="py-0 text-md-right">
											<div class="cl-dark-green font-size-11 font-weight-bold">{{ detailTransactionProduct.transaction_total_price | toRupiah }}</div>
										</v-col>
									</div>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
		}
	},
	props: ['detailTransactionProduct'],
	computed: {
		sumTotal() {
			let total = 0
			this.detailTransactionProduct.transaction_detail.forEach((el) => {
				total += (parseInt(el.transaction_detail_unit_price) + parseInt(el.transaction_detail_product_admin_charge_value) - parseInt(el.transaction_detail_product_discount_value)) * parseInt(el.transaction_detail_qty)
			})
			return total
		},
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>